var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"numbered-bullet"},[_c('div',{staticClass:"circle",class:_vm.variant},[_c('span',{staticClass:"number"},[_vm._v(_vm._s(_vm.number))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }